import React, { useState, useEffect } from 'react';
import axios from "axios";

const Call_php_iniziale = (props) => {


  const [file_utente_caricata, set_in_file_utente_caricata] = useState(false);
  const [file_utente_caricata2, set_in_file_utente_caricata2] = useState(false);

  useEffect(() => {
    console.log('useEffect Call_php_iniziale')
    if (file_utente_caricata) {
      //        controlla_i_dati_caricati_aggiorna_array()
      //        chiamata_file_php_caricamento_utente_todo()
      aggiunta_dati_di_default()
      set_in_file_utente_caricata(false)
      chiamata_file_php_utente()
    }
    if (file_utente_caricata2) {
      //        controlla_i_dati_caricati_aggiorna_array()
      //        chiamata_file_php_caricamento_utente_todo()
      set_in_file_utente_caricata2(false)
      confronto_tra_due_file_per_aggiornamento()
    }
    // Good!
  }, [file_utente_caricata, file_utente_caricata2]);

  // import axios from "axios";

  const confronto_tra_due_file_per_aggiornamento = () => {
    let lista_aux = props.lista_file_mp3
    console.log(lista_aux)
    let lista_aux2 = props.dati_utente
    console.log(lista_aux2)
    var vettore = []
    var roots = lista_aux.map(function (item, index) {
      vettore.push(index)
      var roots2 = lista_aux2.file.map(function (item2, index2) {
        if (item.n_q == item2.n_q) {
          lista_aux[index] = item2
        }
      });


    });

    var roots2 = lista_aux2.file.map(function (item2, index2) {
      if (item2.n_q == 'undefined') {
        lista_aux.push(item2)
      }
    });

    props.funzione_set_lista_materie(lista_aux2.topic)
    props.funzione_set_lista_file(lista_aux)
    props.set_funzione_aggiorna_lista(1)
  }


  const aggiunta_dati_di_default = () => {
    let lista_aux = [...props.lista_file_mp3]
    console.log(lista_aux)

    var roots = lista_aux.map(function (item, index) {
      lista_aux[index].indice_aux = 10
      lista_aux[index].indice_end = 10
      lista_aux[index].materia = 'new'
      lista_aux[index].risposta = 'insert da call_php_start.js'

    });
    console.log('aggiunta_dati_di_default')
    console.log(lista_aux)
    props.funzione_set_lista_file(lista_aux)

  }


  const chiamata_file_php_utente = () => {
    var formData = { "nome": 'renato', "cognome": 'zero' };
    axios({
      method: "post",
      url: 'https://www.idroslab.com/react_walkmind/carica_utente.php',
      headers: { "content-type": "application/json" },
      data: formData
    }).then(data => {
      if (data.data !== 'non_trovato') {
        console.log('YYY UTENTE LOAD OK')
        console.log(data.data)
        console.log('-------------------')

        props.funzione_set_dati_utente(data.data)
        set_in_file_utente_caricata2(true)
      } else { console.log('YYY UTENTE LOAD NO') }
    }
    ).catch(err => {
      console.log('errore in axios')
      console.log(err)
      return null
    })
  };


  const chiamata_file_php = () => {
    var formData = { "name": "John", "age": 30, "car": null };
    axios({
      method: "post",
      url: 'https://www.idroslab.com/react_walkmind/lista_file_mp3.php',
      headers: { "content-type": "application/json" },
      data: formData
    }).then(data => {
      if (data.data !== 'non_trovato') {
        console.log('YYYYYY CARICAMENTO RIUSCITO')
        props.funzione_set_lista_file(data.data)
        set_in_file_utente_caricata(true)
      } else { console.log('YYYYYY CARICAMENTO NO') }
      console.log('ciao')
    }
    ).catch(err => {
      console.log('errore in axios')
      console.log(err)
      return null
    })
  };

  return (
    <button onClick={chiamata_file_php}>Chiamata axios per lista</button>
  )

}

export default Call_php_iniziale;